export const OPEN_FLOW_LOADER = 'OPEN_FLOW_LOADER'
export const CLOSE_FLOW_LOADER = 'CLOSE_FLOW_LOADER'
export const RESET_FLOW_LOADER = 'RESET_FLOW_LOADER'
